import React, { useEffect } from 'react'
import { Layout } from './layout/Layout';
import { Switch, Route, Redirect } from 'react-router-dom';
import Todo from './components/Todo/Todo';
import { Auth } from './components/Auth/Auth';
import Reg from './components/Reg/Reg';
import { About } from './components/About/About';
import './global.scss'
import { Context } from './context';
import { useState } from 'react';
import { auth } from './firebaseConfig';

function App() {

  const [user, setUser] = useState()

  console.log(user)

  useEffect(() => {
    let unsubscribeFromAuth = null

    unsubscribeFromAuth = auth.onAuthStateChanged(user => {
      user ? setUser(user) : setUser(null)
    })

    return () => unsubscribeFromAuth();
  }, [])

  let routes

  if (user) {
    routes = (
      <Switch>
        <Route path="/todo" component={Todo} />
        <Route path="/about" component={About} />
        <Redirect to="/todo" />
      </Switch>

    )
  } else {
    routes = (
      <Switch>
        <Route exact path="/auth" component={Auth} />
        <Route path="/reg" component={Reg} />
        <Route path="/about" component={About} />
        <Redirect to='/auth' />
      </Switch>
    )

  }


  return (
    <Context.Provider value={{ user, setUser }}>
      <Layout>
        {routes}
      </Layout>
    </Context.Provider>
  )
}

export default App